import { render } from "./DashboardIndex.vue?vue&type=template&id=6c128de2"
import script from "./DashboardIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Dashboard/DashboardIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c128de2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c128de2', __exports__)) {
    api.reload('6c128de2', __exports__)
  }
  
  module.hot.accept("./DashboardIndex.vue?vue&type=template&id=6c128de2", () => {
    api.rerender('6c128de2', render)
  })

}


export default __exports__